import { render, staticRenderFns } from "./Production.vue?vue&type=template&id=94a0e244&lang=pug&"
import script from "./Production.vue?vue&type=script&lang=ts&"
export * from "./Production.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports